import type { BoxProps } from '@hover/blueprint';
import { Body, Box } from '@hover/blueprint';
import React from 'react';

import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

interface CountItemsHeaderProps extends BoxProps {
  category: string | React.ReactNode;
  count: number;
}

const CountItemsHeader = ({
  category,
  count,
  ...props
}: CountItemsHeaderProps) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);

  return (
    <Box
      flexDirection="row"
      justifyContent="space-between"
      width={1}
      {...props}
    >
      {category}
      <Body color="neutral.600" marginTop={0}>{`${count} ${t(
        'menu.colorPicker.allCategoriesCount',
      )}`}</Body>
    </Box>
  );
};

export { CountItemsHeader };
